// ============================================
// COMPOSITION SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// ============================================
import React from 'react';

/**
 * Section Composition du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const CompositionSection = ({ ctx }) => {
  const {
    formData,
    handleNestedChange,
    getFieldsConfig
  } = ctx;

  const config = getFieldsConfig();
  const compositionConfig = config?.fullConfig?.onglets?.composition;

  if (!compositionConfig) {
    return (
      <div className="p-8 text-center text-gray-500">
        <i className="bi bi-exclamation-triangle text-4xl mb-3 block"></i>
        <p>Configuration de l'onglet Composition non disponible</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-teal-500/5 via-cyan-500/5 to-blue-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-teal-600/10 to-cyan-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-teal-500/25">
            <i className="bi bi-rulers text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-teal-600 bg-clip-text text-transparent">
              Composition & Surfaces
            </h2>
            <p className="text-gray-600 font-medium">
              Détaillez les surfaces et caractéristiques techniques
            </p>
          </div>
        </div>
      </div>

      {/* Surfaces principales */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Surfaces</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Superficie totale (m²)</label>
            <input
              type="number"
              value={formData.composition?.superficie_totale || ''}
              onChange={(e) => handleNestedChange('composition', 'superficie_totale', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Surface de vente (m²)</label>
            <input
              type="number"
              value={formData.composition?.surface_vente || ''}
              onChange={(e) => handleNestedChange('composition', 'surface_vente', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Réserve (m²)</label>
            <input
              type="number"
              value={formData.composition?.reserve || ''}
              onChange={(e) => handleNestedChange('composition', 'reserve', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompositionSection;
